@if(media() && media().length > 0) {
<div class="media-preview-grid" cdkDropListGroup>
  @for(mediaSrc of mediaSources(); track $index) {
  <div
    class="grid-drop-list"
    cdkDropList
    cdkDropListOrientation="horizontal"
    [cdkDropListData]="$index"
    (cdkDropListDropped)="drop($event)"
  >
    <div cdkDrag class="drag-element">
      <div class="tile-image">
        <img class="tile-image rounded" [ngSrc]="mediaSrc" fill />
      </div>
      <!-- <button
        class="bl-fab"
        mat-icon-button
        aria-label="icon button with a trash icon"
        (click)="editMedia(index)"
      >
        <mat-icon>edit</mat-icon>
      </button> -->
      <button
        class="br-fab"
        color="warn"
        mat-icon-button
        aria-label="icon button with a trash icon"
        (click)="removeMedia($index)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  }
</div>
}
